// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Highlighter as RawHighlighter } from "lucide-react";
export const Highlighter = /* @__PURE__ */ createIcon(RawHighlighter, "Highlighter", 2);
